import { bool, node, object, shape, string } from 'prop-types'

export default function Leaf({ attributes, children, leaf }) {
  if (leaf.bold) children = <strong>{children}</strong>
  if (leaf.italic) children = <em>{children}</em>
  if (leaf.underline) children = <u>{children}</u>
  if (leaf.color) children = <span style={{ color: leaf.color }}>{children}</span>

  return <span {...attributes}>{children}</span>
}

Leaf.propTypes = {
  attributes: object,
  children: node,
  leaf: shape({ bold: bool, italic: bool, underline: bool, color: string }),
}
